import React, { useState } from 'react';
import { ShoppingCart, Package, AlertCircle, CreditCard, Check } from 'lucide-react';

// ============================================================
// STRIPE INTEGRATION
// 1. Replace STRIPE_PUBLIC_KEY with your Stripe publishable key
// 2. Update PRICE_IDS with your actual Stripe Price IDs
//    Create prices at: https://dashboard.stripe.com/products
// 3. Deploy a backend endpoint (Supabase Edge Function or Netlify
//    function) to create Checkout Sessions securely
// ============================================================
const STRIPE_PUBLIC_KEY = process.env.REACT_APP_STRIPE_PUBLIC_KEY || 'pk_test_YOUR_KEY';

// ── Paste your Stripe price_xxx IDs below after creating products ──────────
const PRODUCTS = [
  // ELECTRODES — NGX ELEC-022 (2"×2")
  { id: 'elec-022-full', name: 'Electrodes 2"×2" — Full Case (100 boxes)', sku: 'NGX-ELEC-022', priceId: 'price_ELEC022_FULL', description: '100 boxes · 4 electrodes/box · Single-user reusable · Square or round. Best value.', price: 500.00, unit: 'per case', category: 'Electrodes', inStock: true, popular: true, detail: '$5.00/pkg' },
  { id: 'elec-022-half', name: 'Electrodes 2"×2" — Half Case (50 boxes)', sku: 'NGX-ELEC-022', priceId: 'price_ELEC022_HALF', description: '50 boxes · 4 electrodes/box · Single-user reusable · Square or round.', price: 300.00, unit: 'per half case', category: 'Electrodes', inStock: true, detail: '$6.00/pkg' },
  { id: 'elec-022-qtr', name: 'Electrodes 2"×2" — Quarter Case (25 boxes)', sku: 'NGX-ELEC-022', priceId: 'price_ELEC022_QTR', description: '25 boxes · 4 electrodes/box · Single-user reusable · Square or round.', price: 175.00, unit: 'per quarter case', category: 'Electrodes', inStock: true, detail: '$7.00/pkg' },
  // ELECTRODES — NGX ELEC-039 (2"×4")
  { id: 'elec-039-full', name: 'Electrodes 2"×4" — Full Case (50 boxes)', sku: 'NGX-ELEC-039', priceId: 'price_ELEC039_FULL', description: '50 boxes · 4 electrodes/box · Single-user reusable · Rectangular. Best value.', price: 400.00, unit: 'per case', category: 'Electrodes', inStock: true, popular: true, detail: '$8.00/pkg' },
  { id: 'elec-039-half', name: 'Electrodes 2"×4" — Half Case (25 boxes)', sku: 'NGX-ELEC-039', priceId: 'price_ELEC039_HALF', description: '25 boxes · 4 electrodes/box · Single-user reusable · Rectangular.', price: 225.00, unit: 'per half case', category: 'Electrodes', inStock: true, detail: '$9.00/pkg' },
  { id: 'elec-039-qtr', name: 'Electrodes 2"×4" — Quarter Case (12 boxes)', sku: 'NGX-ELEC-039', priceId: 'price_ELEC039_QTR', description: '12 boxes · 4 electrodes/box · Single-user reusable · Rectangular.', price: 120.00, unit: 'per quarter case', category: 'Electrodes', inStock: true, detail: '$10.00/pkg' },
  // CABLES — Locking
  { id: 'lock-070-4', name: 'Locking Cables — 4 Set Case', sku: 'NGX-LOCK-070', priceId: 'price_LOCK070_4', description: '4 sets · 1 Blue & 1 Yellow per set · 96" Device-Lock Primary. Best value.', price: 1200.00, unit: 'per 4-set case', category: 'Cables', inStock: true, popular: true, detail: '$300/set' },
  { id: 'lock-070-2', name: 'Locking Cables — 2 Set', sku: 'NGX-LOCK-070', priceId: 'price_LOCK070_2', description: '2 sets · 1 Blue & 1 Yellow per set · 96" Device-Lock Primary.', price: 650.00, unit: 'per 2 sets', category: 'Cables', inStock: true, detail: '$325/set' },
  { id: 'lock-070-1', name: 'Locking Cables — 1 Set', sku: 'NGX-LOCK-070', priceId: 'price_LOCK070_1', description: '1 set · 1 Blue & 1 Yellow · 96" Device-Lock Primary.', price: 350.00, unit: 'per set', category: 'Cables', inStock: true, detail: '$350/set' },
  // CABLES — Bifurcating
  { id: 'bifc-080-4', name: 'Bifurcating Cables — 4 Set Case', sku: 'NGX-BIFC-080', priceId: 'price_BIFC080_4', description: '4 sets · 2 Blue & 2 Yellow per set · 20" Y-Extend Secondary. Best value.', price: 600.00, unit: 'per 4-set case', category: 'Cables', inStock: true, detail: '$150/set' },
  { id: 'bifc-080-2', name: 'Bifurcating Cables — 2 Set', sku: 'NGX-BIFC-080', priceId: 'price_BIFC080_2', description: '2 sets · 2 Blue & 2 Yellow per set · 20" Y-Extend Secondary.', price: 350.00, unit: 'per 2 sets', category: 'Cables', inStock: true, detail: '$175/set' },
  { id: 'bifc-080-1', name: 'Bifurcating Cables — 1 Set', sku: 'NGX-BIFC-080', priceId: 'price_BIFC080_1', description: '1 set · 2 Blue & 2 Yellow · 20" Y-Extend Secondary.', price: 200.00, unit: 'per set', category: 'Cables', inStock: true, detail: '$200/set' },
  // CART & REPLACEMENT PARTS
  { id: 'ngx-cart', name: 'NGX Cart — Integrated Workstation', sku: 'NGX-CART', priceId: 'price_CART', description: 'Integrated workstation · 36" height · Includes storage and cable management.', price: 1599.00, unit: 'each', category: 'Cart & Parts', inStock: true, detail: '1 unit' },
  { id: 'ngx-remote-1', name: 'NGX Remote Control Assembly', sku: 'NGX-REMOTE', priceId: 'price_REMOTE_1', description: 'Manual handheld remote control assembly. Single unit.', price: 999.00, unit: 'each', category: 'Cart & Parts', inStock: true, detail: '1 unit' },
  { id: 'ngx-remote-2', name: 'NGX Remote Control — 2 Pack', sku: 'NGX-REMOTE-2', priceId: 'price_REMOTE_2', description: 'Manual handheld remote control assembly. 2-pack discount.', price: 1600.00, unit: 'per 2-pack', category: 'Cart & Parts', inStock: true, detail: '$800 each' },
  { id: 'ngx-power', name: 'NGX Wall Charger / Power Cord', sku: 'NGX-POWER', priceId: 'price_POWER', description: '3-prong adaptable wall charger and power cord. Replacement unit.', price: 200.00, unit: 'each', category: 'Cart & Parts', inStock: true, detail: '1 unit' },
  { id: 'ngx-battery', name: 'NGX Medical-Grade Battery', sku: 'NGX-BATTERY', priceId: 'price_BATTERY', description: '12V medical-grade replacement battery.', price: 100.00, unit: 'each', category: 'Cart & Parts', inStock: true, detail: '1 unit' },
  { id: 'ngx-fuse', name: 'NGX Fuse Set', sku: 'NGX-FUSE', priceId: 'price_FUSE', description: '300VAC fuse set. 2-pack.', price: 10.00, unit: 'per 2-pack', category: 'Cart & Parts', inStock: true, detail: '2 fuses' },
  // SUPPLEMENTS — Nerve Health Solution
  { id: 'supp-6', name: 'Nerve Health Solution — 6 Pack', sku: 'NGX-SUPP-6', priceId: 'price_SUPP_6', description: '6 units. Choose from: Mixed Berry, Green Apple, Peach Lemonade, Pineapple. L-Arginine 5000mg + L-Citrulline formula. Patient retail $79+.', price: 228.00, unit: 'per 6-pack', category: 'Supplements', inStock: true, detail: '$38 each' },
  { id: 'supp-12', name: 'Nerve Health Solution — 12 Pack', sku: 'NGX-SUPP-12', priceId: 'price_SUPP_12', description: '12 units. Choose from: Mixed Berry, Green Apple, Peach Lemonade, Pineapple.', price: 432.00, unit: 'per 12-pack', category: 'Supplements', inStock: true, popular: true, detail: '$36 each' },
  { id: 'supp-18', name: 'Nerve Health Solution — 18 Pack', sku: 'NGX-SUPP-18', priceId: 'price_SUPP_18', description: '18 units. Choose from: Mixed Berry, Green Apple, Peach Lemonade, Pineapple.', price: 612.00, unit: 'per 18-pack', category: 'Supplements', inStock: true, detail: '$34 each' },
  { id: 'supp-24', name: 'Nerve Health Solution — 24 Pack', sku: 'NGX-SUPP-24', priceId: 'price_SUPP_24', description: '24 units. Choose from: Mixed Berry, Green Apple, Peach Lemonade, Pineapple. Best price per unit.', price: 768.00, unit: 'per 24-pack', category: 'Supplements', inStock: true, detail: '$32 each' },
];

const CATEGORIES = ['All', 'Electrodes', 'Cables', 'Cart & Parts', 'Supplements'];

export default function SuppliesPage() {
  const [cart, setCart] = useState({});
  const [quantities, setQuantities] = useState({});
  const [activeCategory, setActiveCategory] = useState('All');
  const [checkoutLoading, setCheckoutLoading] = useState(false);
  const [added, setAdded] = useState({});

  const setQty = (id, val) => {
    const n = Math.max(1, parseInt(val) || 1);
    setQuantities(prev => ({ ...prev, [id]: n }));
  };

  const addToCart = (product) => {
    const qty = quantities[product.id] || 1;
    setCart(prev => ({
      ...prev,
      [product.id]: {
        ...product,
        qty: (prev[product.id]?.qty || 0) + qty
      }
    }));
    setAdded(prev => ({ ...prev, [product.id]: true }));
    setTimeout(() => setAdded(prev => ({ ...prev, [product.id]: false })), 1800);
  };

  const cartCount = Object.values(cart).reduce((s, i) => s + i.qty, 0);
  const cartTotal = Object.values(cart).reduce((s, i) => s + i.price * i.qty, 0);

  const filteredProducts = activeCategory === 'All'
    ? PRODUCTS
    : PRODUCTS.filter(p => p.category === activeCategory);

  const handleCheckout = async () => {
    setCheckoutLoading(true);
    try {
      // ============================================================
      // STRIPE CHECKOUT INTEGRATION
      // Replace this with a call to your backend to create a session:
      //
      // const { loadStripe } = await import('@stripe/stripe-js');
      // const stripe = await loadStripe(STRIPE_PUBLIC_KEY);
      //
      // const lineItems = Object.values(cart).map(item => ({
      //   price: item.priceId,
      //   quantity: item.qty,
      // }));
      //
      // const response = await fetch('/api/create-checkout-session', {
      //   method: 'POST',
      //   headers: { 'Content-Type': 'application/json' },
      //   body: JSON.stringify({ lineItems, customerId: profile?.stripe_customer_id }),
      // });
      // const { sessionId } = await response.json();
      // await stripe.redirectToCheckout({ sessionId });
      // ============================================================

      alert(`Demo: Would initiate Stripe checkout for ${cartCount} item(s) totaling $${cartTotal.toFixed(2)}.\n\nConnect Stripe to enable live checkout.`);
    } finally {
      setCheckoutLoading(false);
    }
  };

  return (
    <>
      <div className="page-header">
        <div>
          <div className="page-title">Reorder Supplies</div>
          <div className="page-subtitle">Preferred Provider pricing applied automatically</div>
        </div>
        {cartCount > 0 && (
          <button className="btn btn-primary" onClick={handleCheckout} disabled={checkoutLoading}>
            <ShoppingCart size={15} />
            Checkout ({cartCount}) · ${cartTotal.toFixed(2)}
          </button>
        )}
      </div>

      <div className="page-body">
        {/* STRIPE SETUP NOTICE */}
        <div className="alert alert-info mb-16">
          <AlertCircle size={15} style={{ flexShrink: 0, marginTop: 1 }} />
          <span>
            <strong>Setup needed:</strong> Configure your Stripe keys in <code>.env</code> and create products at{' '}
            <a href="https://dashboard.stripe.com/products" target="_blank" rel="noopener noreferrer" className="text-link">dashboard.stripe.com</a>{' '}
            to enable live checkout.
          </span>
        </div>

        {/* TABS */}
        <div className="tabs">
          {CATEGORIES.map(cat => (
            <button
              key={cat}
              className={`tab ${activeCategory === cat ? 'active' : ''}`}
              onClick={() => setActiveCategory(cat)}
            >
              {cat}
            </button>
          ))}
        </div>

        {/* CART MINI */}
        {cartCount > 0 && (
          <div style={{
            background: 'white', border: '1px solid #e2e8f0', borderRadius: 10,
            padding: '14px 18px', marginBottom: 20, display: 'flex',
            alignItems: 'center', justifyContent: 'space-between', gap: 12
          }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
              <ShoppingCart size={16} color="#10497c" />
              <span style={{ fontWeight: 500, fontSize: 13.5 }}>
                {cartCount} item{cartCount !== 1 ? 's' : ''} in cart
              </span>
              <span style={{ color: '#64748b', fontSize: 13 }}>·</span>
              <span style={{ fontWeight: 700, color: '#10497c' }}>${cartTotal.toFixed(2)}</span>
            </div>
            <div style={{ display: 'flex', gap: 8 }}>
              <button className="btn btn-secondary btn-sm" onClick={() => setCart({})}>Clear</button>
              <button className="btn btn-primary btn-sm" onClick={handleCheckout} disabled={checkoutLoading}>
                <CreditCard size={13} />
                Checkout with Stripe
              </button>
            </div>
          </div>
        )}

        {/* PRODUCTS */}
        <div className="products-grid">
          {filteredProducts.map(product => (
            <div key={product.id} className="product-card">
              <div className="product-image">
                <Package size={48} className="product-image-placeholder" />
                {product.popular && (
                  <div style={{
                    position: 'absolute', top: 8, right: 8,
                    background: '#ec008c', color: 'white',
                    padding: '2px 8px', borderRadius: 100, fontSize: 10, fontWeight: 600
                  }}>Popular</div>
                )}
                {product.isNew && (
                  <div style={{
                    position: 'absolute', top: 8, right: 8,
                    background: '#21999d', color: 'white',
                    padding: '2px 8px', borderRadius: 100, fontSize: 10, fontWeight: 600
                  }}>New</div>
                )}
              </div>

              <div className="product-info">
                <div className="product-name">{product.name}</div>
                <div className="product-sku">SKU: {product.sku}</div>
                <p style={{ fontSize: 12, color: '#64748b', margin: '8px 0', lineHeight: 1.4 }}>
                  {product.description}
                </p>
                <div className="product-price">
                  ${product.price.toFixed(2)}
                  <small> {product.unit}</small>
                </div>
                {product.detail && (
                  <div style={{ fontSize: 11, color: '#21999d', fontWeight: 500, marginBottom: 6 }}>
                    {product.detail}
                  </div>
                )}

                {!product.inStock ? (
                  <div style={{ color: '#dc2626', fontSize: 12, fontWeight: 500 }}>Out of Stock</div>
                ) : (
                  <div className="product-actions">
                    <input
                      type="number"
                      className="product-qty"
                      min="1"
                      value={quantities[product.id] || 1}
                      onChange={e => setQty(product.id, e.target.value)}
                    />
                    <button
                      className={`btn ${added[product.id] ? 'btn-teal' : 'btn-primary'}`}
                      style={{ flex: 1 }}
                      onClick={() => addToCart(product)}
                    >
                      {added[product.id] ? (
                        <><Check size={13} /> Added</>
                      ) : (
                        <><ShoppingCart size={13} /> Add to Cart</>
                      )}
                    </button>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>

        {/* SUBSCRIPTION CTA */}
        <div style={{ marginTop: 32 }}>
          <div className="subscription-card active-plan">
            <div>
              <div style={{ fontWeight: 600, fontSize: 15, color: '#1e293b' }}>Auto-Replenishment Available</div>
              <div style={{ fontSize: 13, color: '#64748b', marginTop: 4 }}>
                Set up a monthly subscription via Stripe to automatically reorder your most-used supplies. Save 5% and never run out.
              </div>
            </div>
            <button className="btn btn-teal" style={{ whiteSpace: 'nowrap', flexShrink: 0 }}>
              Set Up Auto-Order
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
